import React from 'react';
import { Page } from '../../page/page';
import { CodeEditor } from '../../code-editor/code-editor';
import { HintModal } from '../../modal/hint-modal';

import './example-A.css';

const css =  {
  isEditable: true,
  initial: ".square {\n  width: 100px;\n  height: 100px;\n  background-color: #F25B21;\n}",
}

const html = {
  isEditable: true,
  initial: "<div class='square'></div>"
}

const js = {
  isEditable: false,
  initial: "",
}

export const ExampleA = (props) => {
  return <Page html={html} css={css} js={js}>
    <div className="example">
      <h1 className="title">Challenge 1: Rotation and Color Change</h1>
      <div className="instructions">Using the <a target="_blank" href="https://www.w3schools.com/cssref/css3_pr_transform.asp"><code>transform</code></a> property, animate the square to match the one shown</div>
      <div className="square"></div>
      <HintModal>
        First define your animation:
        <pre>
          <div className="code">
            { `@keyframes nameOfAnimation {`} <br/>
            { `   from { /* starting values */}`}<br/>
            { `   to { /* ending values */ }`}<br/>
            { `}`}
          </div>
        </pre>
        Then add it to the DOM element:
        <pre>
          <div className="code">
            { `.square {`}<br/>
            { `    ...`}<br/>
            { `    animation: name, duration... `} <br/>
            { `}`}<br/>
          </div>
        </pre>
      </HintModal>
    </div>
    <CodeEditor html={html} css={css} js={js} defaultTab={'css'} />
  </Page>
}
